<template>
  <v-slide-x-reverse-transition>
    <sn-shadow
      v-if="value"
      :class="[toastStyles.color, { 'alert' : !isMobileToast, 'mobile-alert': isMobileToast }]"
      :shadow-depth="4"
    >
      <v-container
        pa-4
        :data-cy="`${event}-toast`"
      >
        <v-row
          no-gutters
          align="center"
          class="flex-nowrap"
        >
          <v-col
            cols="auto"
            class="pa-1"
          >
            <v-icon
              :color="toastStyles.iconColor"
              size="24"
            >
              {{ toastStyles.icon }}
            </v-icon>
          </v-col>
          <v-col class="mx-2 fill-column">
            <div
              :class="`sn-${description ? 'subtitle' : 'body'}-1 sn-text-primary`"
              data-cy="toast-message"
            >
              {{ message }}
            </div>
            <div
              v-if="description"
              class="sn-body-2 sn-text-primary-01 mt-1"
              data-cy="toast-description"
            >
              {{ description }}
            </div>
          </v-col>
          <v-col
            v-if="isAction"
            cols="auto"
            class="sn-btn px-4 py-2 pointer"
            data-cy="toast-action-button"
            @click="actionClicked"
          >
            {{ actionText }}
          </v-col>
          <v-col
            v-if="isSticky"
            cols="auto"
          >
            <sn-btn
              text=""
              type="text"
              data-cy="close-toast-btn"
              prepend-icon="$snExit"
              @click="close"
            />
          </v-col>
        </v-row>
      </v-container>
    </sn-shadow>
  </v-slide-x-reverse-transition>
</template>
<script>

import snBtn from '~/components/snui/v2/snBtn/snBtn'
import snShadow from '~/components/snui/v2/snShadow/snShadow'

export default {
  name: 'SnToast',
  components: {
    snBtn,
    snShadow
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    type: {
      type: String,
      default: 'simple',
      validator (type) {
        return ['simple', 'sticky', 'action'].includes(type)
      }
    },
    event: {
      type: String,
      default: 'success',
      validator (type) {
        return ['success', 'warning', 'error', 'info'].includes(type)
      }
    },
    message: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: false,
      default: null
    },
    actionText: {
      type: String,
      required: false,
      default: 'Action'
    },
    isMobileToast: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    toastStyles () {
      switch (this.event) {
        case 'success':
          return {
            color: 'snSuccess01',
            iconColor: 'snSuccess',
            icon: '$snCheckCircle'
          }
        case 'warning':
          return {
            color: 'snCaution01',
            iconColor: 'snCaution',
            icon: '$snWarning'
          }
        case 'error':
          return {
            color: 'snError01',
            iconColor: 'snError',
            icon: '$snRestricted'
          }
        default: // info
          return {
            color: 'snWhite',
            iconColor: 'snPrimary',
            icon: '$snInfo'
          }
      }
    },
    isSticky () {
      return this.type === 'sticky'
    },
    isAction () {
      return this.type === 'action'
    }
  },
  watch: {
    value (newToast) {
      if (newToast && !this.isSticky) {
        // according to SNUI, a non-sticky toast is supposed to stay active for 7 seconds
        setTimeout(this.close, 7000)
      }
    }
  },
  methods: {
    close () {
      this.$emit('input', false)
    },
    actionClicked () {
      this.$emit('actionClicked')
      this.close()
    }
  }
}

</script>

<style lang="scss" scoped>

//position is fixed on page, this is according to designs, may be subject to change
.alert {
  z-index: 10;
  position: fixed;
  right: 24px;
  bottom: 24px;
  width: 340px;
}

.mobile-alert {
  z-index: 10;
  position: fixed;
  right: 24px;
  bottom: 100px;
  width: 340px;
}

.fill-column {
  // This styling here ensures that really long text with no space between wraps to a new line while also filling up as much space as is available
  overflow-wrap: break-word;
  flex-grow: 1;
  // min-width here is required for the flex-grow style to work properly. Here's an interesting article that explains it in more detail:
  // https://github.com/philipwalton/flexbugs
  min-width: 0px;
}

.pointer {
  cursor: pointer;
}
</style>
